import { gql } from "@apollo/client";

export const FETCH_PARTNER_CONSENT_PERMISSIONS = gql`
  query FetchPartnerConsentPermissions($partner: Partner!) {
    me {
      partnerConsentPermissions(partner: $partner) {
        id
        permissionGrantedAt
        permissions
      }
    }
  }
`;

export const GRANT_PARTNER_CONSENT = gql`
  mutation GrantPartnerConsent(
    $partner: Partner!
    $permissions: [PartnerPermissionEnum!]!
  ) {
    grantPartnerConsent(partner: $partner, permissions: $permissions)
  }
`;

export const REVOKE_PARTNER_CONSENT = gql`
  mutation RevokePartnerConsent(
    $partner: Partner!
    $permissions: [PartnerPermissionEnum!]!
  ) {
    revokePartnerConsent(partner: $partner, permissions: $permissions)
  }
`;

export const UPSERT_APEX_SETTINGS = gql`
  mutation UpsertApexSettings(
    $revenueType: String!
    $attributionModel: String!
    $attributionWindow: String!
    $accountingMode: String!
  ) {
    upsertApexSettings(
      revenueType: $revenueType
      attributionModel: $attributionModel
      attributionWindow: $attributionWindow
      accountingMode: $accountingMode
    ) {
      revenueType
      attributionModel
      attributionWindow
      accountingMode
    }
  }
`;

export const FETCH_PARTNERS_CVE_CONSENT = gql`
  query FetchPartnersCVEConsent {
    me {
      partnerCVEConsent {
        partner
        permission
        hasConsent
        hasConnectedAccounts
      }
      preferredCvePartner
    }
  }
`;

export const FETCH_PARTNERS_APEX_CONSENT = gql`
  query FetchPartnersApexConsent {
    me {
      partnerApexConsent {
        partner
        permission
        hasConsent
        hasConnectedAccounts
      }
      apexSettings {
        revenueType
        attributionModel
        attributionWindow
        accountingMode
      }
    }
  }
`;

export const UPSERT_PREFERRED_CVE_PARTNER = gql`
  mutation UpsertPreferredCvePartner($partner: Partner!) {
    upsertPreferredCvePartner(partner: $partner)
  }
`;
